export default {
  CREATE: `Créer une position`,
  DELETE_BUTTON: {
    TITLE: `Supprimer la position`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette position ?`,
    PRIMARY_ACTION: `Supprimer la position`,
    BAD_MATCH: `La saisie ne correspond pas au mot "SUPPRIMER"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    DELETE: {
      LABEL: `Entrez "SUPPRIMER" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  LIST: {
    TITLE: `Liste des positions`
  },
  PUNCH_RULE: `Règle des cartes de temps`,
  NON_ASSIGNABLE: `Non assignable`,
  ATTRIBUTES_HEADER: `Attributs`,
  ATTRIBUTES: {
    TITLE: `Attributs`,
    DESCRIPTION: `Les attributs permettent de déterminer l'éligibilité des utilisateurs selon les qualifications, exigences ou restrictions qu'ils possèdent.`
  },
  DEPARTMENTS: `Départements`,
  COMPANY_ID: `Identifiant de compagnie`,
  CUSTOM_FIELD_1: `Champ personnalisé 1`,
  CUSTOM_FIELD_2: `Champ personnalisé 2`,
  WILL_BE_IMPACTED: `La quantité d'éléments qui seront impactés (supprimés ou réassignés)`,
  DELETE_AMOUNT_POSITION: `Position (réassignation)`,
  DELETE_AMOUNT_SHIFT: `Quart de travail (suppression)`,
  DELETE_AMOUNT_PROJECTS: `Position requise pour un projet`,
  DELETE_AMOUNT_USERS: `Assignation aux utilisateurs (assignation à aucun utilisateur)`,
  DELETE_AMOUNT_TEMPLATE_EVENTS: `Quart de travail selon des modèles d'horaire`,
  form: {
    CREATE: {
      TITLE: `Création d'une position`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'une position`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom de la position`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement la repérer.`,
      PLACEHOLDER: `Entrez un nom pour la position`
    },
    POSITIONCODE: {
      LABEL: `Code de position`,
      DESCRIPTION: `Le code de position est utilisé dans les outils d'importation.`,
      PLACEHOLDER: `Entrez un code pour la position`
    },
    COMPANYID: {
      LABEL: `Identifiant de compagnie (paie)`,
      DESCRIPTION: `L'identifiant de compagnie est utilisé pour remplacer l'identifiant de la compagnie dans l'export de paie.`,
      PLACEHOLDER: `Entrez l'identifiant de la compagnie`
    },
    CUSTOMFIELD1: {
      LABEL: `Champ personnalisé 1`,
      DESCRIPTION: `Le champ personnalisé 1 est utilisé par certaines intégrations, vous pouvez le laisser vide.`,
      PLACEHOLDER: `Entrez une valeur pour le champ personnalisé 1`
    },
    CUSTOMFIELD2: {
      LABEL: `Champ personnalisé 2`,
      DESCRIPTION: `Le champ personnalisé 2 est utilisé par certaines intégrations, vous pouvez le laisser vide.`,
      PLACEHOLDER: `Entrez une valeur pour le champ personnalisé 2`
    },
    PUNCHRULE: {
      LABEL: `Règle de carte de temps`,
      DESCRIPTION: `Tous les quarts de travail assignés à cette position vont utiliser cette règle de validation pour les cartes de temps.`
    },
    DEPARTMENTS: {
      LABEL: `Département`,
      DESCRIPTION: `Départements de la position`
    },
    NONASSIGNABLE: {
      LABEL: `Non assignable`,
      DESCRIPTION: `Désigne une position descriptive dans l'horaire, à laquelle il ne sera pas possible d'assigner des utilisateurs.`
    },
    ATTRIBUTENAME: {
      LABEL: `Attribut`,
      DESCRIPTION: ``
    },
    RANK: {
      LABEL: `Niveau de formation`,
      DESCRIPTION: ``
    },
    EXPIRATIONDATE: {
      LABEL: `Date d'expiration`,
      DESCRIPTION: ``
    },
    NAME_REQUIRED: `Le nom de la position est obligatoire.`
  }
}
